import styled from '@emotion/styled';
import { Modal } from '@lightspeed/flame/Modal';

export const StyledModal = styled(Modal)`
  max-width: 600px;
  width: 600px;
`;
